/**
 * Routes where the main app sidebar should stay collapsed (icon mode) so nested
 * panes (e.g. the Candidates list · conversation · detail columns) have more
 * horizontal room.
 */

/**
 * Set to true to auto-collapse the main nav when entering Intelligence chat.
 * Set to false to keep the full nav visible there.
 * The user can always manually toggle the nav width with the sidebar button.
 */
export const INTELLIGENCE_COLLAPSES_NAV = false;

const FORCE_COLLAPSED_PATH_PREFIXES = ["/recruit/candidates"] as const;

/** The Coach chat and every page under it. */
function isIntelligencePath(pathname: string): boolean {
  return pathname === "/coach" || pathname.startsWith("/coach/");
}

export function pathnameForcesSidebarCollapsed(pathname: string): boolean {
  return (
    FORCE_COLLAPSED_PATH_PREFIXES.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    ) ||
    (INTELLIGENCE_COLLAPSES_NAV && isIntelligencePath(pathname))
  );
}
